import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import $ from 'jquery';
import { Utils } from './Utils';

@Injectable({
    providedIn: 'root'
})
export class SPService {

    constructor(private http: HttpClient) {

    }

    public getFormDigest(configUrl: string): Observable<string> {

        return new Observable<string>((observable) => {
            const formDigest = $('#__REQUESTDIGEST').val();
            if (formDigest) {
                observable.next(formDigest as string);
                observable.complete();
            } else {
                this.http.post(Utils.removeSlash(configUrl) + '/_api/contextinfo', '')
                .subscribe((data) => {
                    try {
                        observable.next((<any>data).FormDigestValue);
                    } catch (error) {
                        observable.error(error);
                    } finally {
                        observable.complete();
                    }
                }, (error: any) => {
                    observable.error(error);
                    observable.complete();
                });
            }
        });
    }
}
